export const TIANJI_MESSAGES: Readonly<Record<string, string>> = {
  "Copy code block": "复制代码",
  " Limited to 500 rows and 50 columns.": " 最多显示 500 行、50 列。",
  " Preview limited to 250,000 rows, 1,024 columns, and bounded cell text.":
    " 预览最多支持 250,000 行、1,024 列，单元格文本也有长度限制。",
  " Totals include all changes.": " 统计包含全部更改。",
  ", so requests here use your own GitHub login and its lower rate limit.":
    "，因此此处请求使用你的 GitHub 登录，其请求限额更低。",
  ", then create the draft thread in the main repo or in a dedicated worktree.":
    "，然后在主仓库或独立工作树中新建草稿会话。",
  ": Settings → Connections → Create link, then paste its code here.":
    "：设置 → 连接 → 创建链接，然后将配对码粘贴到此处。",
  "(guest)": "（访客）",
  "% zoom": "% 缩放",
  "⌘/Ctrl Enter to send": "⌘/Ctrl Enter 发送",
  "Accessibility data": "无障碍数据",
  "Action failed": "操作失败",
  "Action unavailable": "操作不可用",
  Activity: "活动",
  "Add panel surface": "添加面板内容",
  "Add to chat": "添加到会话",
  Address: "地址",
  Agent: "智能体",
  "Agents here can then launch, message and wait on threads there. Revoke it in that machine's Connections.":
    "关联后，此处智能体可以在该电脑创建会话、发消息并等待结果。可在该电脑的“连接”中撤销。",
  ago: "前",
  Allow: "允许",
  "Already up to date": "已是最新",
  "Also on": "同时位于",
  "An agent investigates a T3 Code problem and helps file an issue":
    "由智能体调查 T3 Code 问题并协助提交问题报告",
  "An approval is already being answered, so your message wasn't sent.":
    "已有审批正在响应，因此消息未发送。",
  "and bring the local files git does not track.": "并携带 Git\n              未跟踪的本地文件。",
  "Annotated preview crop": "带标注的预览区域",
  "Another address…": "其他地址…",
  "Another approval arrived, so your message wasn't sent.": "收到新的审批，因此消息未发送。",
  "Another copy is in progress.": "另一项复制操作正在进行。",
  app: "应用",
  "app left its page and was stopped": "应用离开原页面后已停止",
  "app was closed": "应用已关闭",
  "Approval declined. Your message changed, so it wasn't sent.":
    "已拒绝审批。消息发生变化，因此未发送。",
  "Approval needed": "需要审批",
  "Archive contents": "压缩包内容",
  "Archived thread": "已归档会话",
  "Ask anything. @ files, $ skills, / commands": "输入消息，@ 文件，$ 技能，/ 命令",
  "Attached thread is on another machine": "附加会话位于另一台电脑",
  "Attempted path": "尝试访问的路径",
  "Audio unavailable. ": "音频不可用。 ",
  "Audio unavailable. Open the file or retry playback.": "音频不可用，请打开文件或重试播放。",
  Automation: "自动任务",
  Automations: "自动任务",
  "Back to": "返回",
  "Back to archive": "返回压缩包",
  "Background setup": "后台设置",
  Backspace: "退格",
  Base: "基础版本",
  "Behind upstream. Pull/rebase first.": "落后于上游，请先拉取或变基。",
  "Branch has diverged from upstream. Rebase/merge first.": "分支已与上游分叉，请先变基或合并。",
  "Branch is behind upstream. Pull/rebase before pushing.":
    "分支落后于上游，请先拉取或变基再推送。",
  Brightness: "亮度",
  "byte file.": "字节。",
  "Cancel auto-resume": "取消自动恢复",
  "Cancel editing queued message": "取消编辑排队消息",
  "Captured window": "已采集的窗口",
  Caution: "注意",
  "Cell values only. Charts, images, and formatting are not shown.":
    "仅显示单元格值，不显示图表、图片和格式。",
  "cells ·": "单元格 ·",
  "changed file": "更改的文件",
  Changes: "更改",
  "ChatGPT usage limit reached": "已达到 ChatGPT 用量限制",
  "Check for updates": "检查更新",
  "Check out feature branch & continue": "检出功能分支并继续",
  "Check the branch out and resolve the conflicts in a new thread":
    "检出此分支，在新会话中解决冲突",
  "Checking file access...": "正在检查文件访问权限…",
  "Checking for updates…": "正在检查更新…",
  "Checking the proxy and the firewall": "检查代理和防火墙",
  "Checking your connection": "检查网络连接",
  "Choose an Antigravity model before sending.": "请先选择 Antigravity 模型，再发送消息。",
  "Choose machine…": "选择电脑…",
  "Choose model": "选择模型",
  "Choose models": "选择模型",
  "Choose snooze date": "选择提醒日期",
  "Choose when snoozed threads return to your inbox.": "选择会话重新出现在待办列表的时间。",
  Cite: "引用",
  "Cite selection in composer": "在输入框中引用所选内容",
  "Clear cache": "清除缓存",
  "Clear cookies": "清除 Cookie",
  "Click the citation to try again.": "点击引用以重试。",
  "Click to compact first": "点击以先压缩",
  "Click to keep full history": "点击以保留完整历史",
  "Click to retry.": "点击重试。",
  "Click to zoom in or return to fit. Scroll to zoom, drag to pan. Use Enter to toggle zoom, plus or minus to zoom, and 0 to fit.":
    "点击放大或适应窗口。滚动缩放，拖动平移；按回车切换缩放，加减号调整比例，按 0 适应窗口。",
  "Close (Esc)": "关闭（Esc）",
  "Close all": "关闭全部",
  "Close browser while the agent is using it?": "智能体正在使用浏览器，仍要关闭吗？",
  "Close find": "关闭查找",
  "Close others": "关闭其他标签页",
  "Close separate preview window": "关闭独立预览窗口",
  "Close to the right": "关闭右侧标签页",
  Collapse: "收起",
  columns: "列",
  "Comments can contain up to": "批注最多允许",
  "Commit & push to default ref?": "提交并推送到默认分支或标签？",
  "Compacting context": "正在压缩上下文",
  "Compacting for": "正在压缩，用时",
  "Complete a run in this fork before merging it back":
    "请先在此分支会话中完成一次执行，再合并回原会话",
  Completed: "已完成",
  "Confirming the dev server is running": "确认开发服务器正在运行",
  "Connect an environment to set up its providers.": "连接环境以配置模型服务。",
  Consumed: "已消耗",
  "Context compacted": "上下文已压缩",
  "Context compaction": "上下文压缩",
  "Context handoff": "上下文交接",
  "Context handoff pending": "等待上下文交接",
  "Context menu": "快捷菜单",
  "Context transfer": "上下文传递",
  Continued: "继续执行",
  Conversation: "会话内容",
  "Conversation fork": "会话分支",
  "Copied error": "错误信息已复制",
  "Copy branch name": "复制分支名",
  "Copy command, for a terminal": "复制供终端使用的命令",
  "Copy contents": "复制内容",
  "Copy error": "复制错误信息",
  "Copy Link": "复制链接",
  "Copy mention": "复制引用",
  "Copy message": "复制消息",
  "Copy preview": "复制预览",
  "Copy relaunch command": "复制重启命令",
  "Copy request for admin": "复制给管理员的申请",
  "Copy thread": "复制会话",
  "Copying files": "正在复制文件",
  "Could not capture the picked element": "无法截取所选元素",
  "Could not change auto-resume": "无法更改自动恢复设置",
  "Could not check permissions. We'll try again automatically.": "无法检查权限，将自动重试。",
  "Could not clear persisted thread sidebar width.": "无法清除已保存的会话侧栏宽度。",
  "Could not copy the request": "无法复制申请",
  "Could not decode this image.": "无法解码此图片。",
  "Could not load automations:": "无法加载自动任务：",
  "Could not load history.": "无法加载历史。",
  "Could not load the cited response": "无法加载引用的回复",
  "Could not load the Office viewer.": "无法加载 Office 查看器。",
  "Could not load this file.": "无法加载此文件。",
  "Could not open the cited response": "无法打开引用的回复",
  "Could not open the link": "无法打开链接",
  "Could not persist sidebar width.": "无法保存侧栏宽度。",
  "Could not read file": "无法读取文件",
  "Could not read persisted thread sidebar width.": "无法读取已保存的会话侧栏宽度。",
  "Could not read the Office viewer response.": "无法读取 Office 查看器响应。",
  "Could not read this file.": "无法读取此文件。",
  "Could not render this Office document.": "无法渲染此 Office 文档。",
  "Could not reopen view": "无法重新打开视图",
  "Could not save file": "无法保存文件",
  "Could not search this PDF.": "无法搜索此 PDF。",
  "Could not send the app's message.": "无法发送应用消息。",
  "Could not snooze thread": "无法设置稍后提醒",
  "Could not start the update": "无法开始更新",
  "Could not start thread": "无法开始会话",
  "Could not stop subagent": "无法停止子智能体",
  "Could not stop workflow": "无法停止工作流",
  "Could not update everything": "无法更新全部组件",
  "Couldn't load output:": "无法加载输出：",
  "Couldn't load work. Click to retry.": "无法加载执行记录，点击重试。",
  "Couldn't save theme selection": "无法保存主题选择",
  "Create a link on": "创建链接于",
  'Create new ref "': "创建分支或标签“",
  "Created thread": "已创建会话",
  "Current thread": "当前会话",
  "Custom snooze": "自定义稍后提醒",
  "Cut off by a steer": "已被调整指令中断",
  Date: "日期",
  "Date and time": "日期和时间",
  Days: "天",
  Declined: "已拒绝",
  "Decrease duration": "缩短时长",
  "Default branch": "默认分支",
  "Default mode. Click to enter plan mode": "执行模式，点击进入计划模式",
  'Delete action "': "删除操作“",
  "Delete comment": "删除批注",
  "Desktop app": "桌面应用",
  "Detached HEAD: create and check out a branch to enable push and":
    "HEAD 已分离，创建并检出分支后才能推送或执行",
  Device: "设备",
  "Device host": "设备主机",
  "Device tab name": "设备标签页名称",
  Diff: "差异",
  "Diff file contents are unavailable for this selection.": "此选择没有可用的差异文件内容。",
  Directories: "目录",
  "Disable word wrap": "关闭自动换行",
  "Dismiss error": "关闭错误提示",
  "Dismiss notification": "关闭通知",
  "Display equation": "独立公式",
  dropped: "已拖入",
  "Edit automation": "编辑自动任务",
  "Edit from here": "从此处编辑",
  "Edit queued message": "编辑排队消息",
  "Edit snooze options": "编辑稍后提醒选项",
  "Editing in the composer": "正在输入框中编辑",
  "Editor opening is unavailable.": "无法打开编辑器。",
  Effort: "力度",
  "Enable word wrap": "开启自动换行",
  Enter: "回车",
  "Enter a path relative to": "输入相对路径，基于",
  "Enter Git clone URL": "输入 Git 克隆地址",
  entries: "项",
  "Environment is not connected.": "环境未连接。",
  exit: "退出",
  "Exit full screen": "退出全屏",
  Expand: "展开",
  "Expand diagram": "展开图表",
  Expanded: "已展开",
  "Expired terminal context": "终端上下文已失效",
  "Expired terminal contexts": "终端上下文已失效",
  "Expires in a moment": "即将过期",
  failed: "失败",
  "Failed to clean up implementation thread after start failure.":
    "开始执行失败后，清理执行会话失败。",
  "Failed to copy branch name": "复制分支名失败",
  "Failed to copy mention": "复制引用失败",
  "Failed to create and switch ref.": "创建并切换分支或标签失败。",
  "Failed to switch ref.": "切换分支或标签失败。",
  Fast: "快速",
  files: "个文件",
  "files.": "个文件。",
  "files. The recorded patch omits": "个文件。记录的补丁未包含其中",
  "Find in thread": "在会话中查找",
  Finished: "已完成",
  "Fit width": "适应宽度",
  Fix: "修复",
  "Fix the failing checks in a new thread": "在新会话中修复失败的检查",
  "Focus Next Workspace Area": "聚焦下一个工作区区域",
  "Focus Previous Workspace Area": "聚焦上一个工作区区域",
  "Folder on": "目标文件夹位于",
  "Font previews are limited to 10 MB.": "字体预览最大支持 10 MB。",
  "for your browser.": "供你的浏览器使用。",
  Fork: "分支会话",
  "Fork from this response": "从此回复新建分支会话",
  "Forked from conversation": "从会话创建了分支",
  "Full file": "完整文件",
  "Full path": "完整路径",
  "Git initialization failed": "Git 初始化失败",
  "Git URL": "Git 地址",
  "Guest request": "访客请求",
  "Hard reload": "强制刷新",
  "Hide details": "隐藏详情",
  "Hide device toolbar": "隐藏设备工具栏",
  "Hide file explorer": "隐藏文件浏览器",
  "Hide test files": "隐藏测试文件",
  Hours: "小时",
  Idle: "空闲",
  "Idle · resumable": "空闲 · 可恢复",
  "Image unavailable. The file may have been moved or deleted.":
    "图片不可用，文件可能已被移动或删除。",
  Important: "重要",
  "In messages": "消息内容",
  "Increase duration": "延长时长",
  "Indexing workspace files…": "正在索引工作区文件…",
  "Initialize Git": "初始化 Git",
  "Inline equation": "行内公式",
  "Input needed": "需要输入",
  "Install Antigravity in provider settings before sending.":
    "请先在模型服务设置中安装 Antigravity，再发送消息。",
  "Install on": "安装到",
  "isn't installed on": "尚未安装于",
  "It may have been removed. The selected text is still saved in your citation.":
    "回复可能已被移除，所选文本仍保存在引用中。",
  "Jump to latest": "跳到最新",
  Keep: "保留",
  Later: "稍后",
  "Latest turn": "最近一轮",
  Lineage: "会话关系",
  Link: "关联",
  "Link a machine": "关联电脑",
  "Link a machine to this environment": "将电脑关联到此环境",
  "Linked pull requests": "关联的拉取请求",
  "Linked thread": "关联会话",
  Listening: "正在监听",
  "load earlier thread history": "加载更早的会话历史",
  "Load earlier turns": "加载更早的轮次",
  "Load earlier turns, then click the citation to try again. Your saved quote is unchanged.":
    "请加载更早的轮次，再点击引用重试。已保存的引用未改变。",
  "Loading changes...": "正在加载更改…",
  "Loading checkpoint diff...": "正在加载检查点差异…",
  "Loading code...": "正在加载代码…",
  "Loading diff…": "正在加载差异…",
  "Loading earlier turns…": "正在加载更早的轮次…",
  "Loading file": "正在加载文件",
  "Loading files…": "正在加载文件…",
  "Loading image…": "正在加载图片…",
  "Loading more refs...": "正在加载更多分支或标签…",
  "Loading refs...": "正在加载分支或标签…",
  "Loading tool call diff...": "正在加载工具调用差异…",
  "Loading uncommitted changes...": "正在加载未提交更改…",
  "Loading work history": "正在加载执行历史",
  "Local servers": "本地服务器",
  "Machine not in this app": "此应用中未添加该电脑",
  "Make room for this message's attachments in the composer before rewinding.":
    "请先为此消息的附件腾出输入框空间，再回退。",
  "Manage scheduled tasks": "管理定时任务",
  "Manual update required": "需要手动更新",
  "Maximize panel": "最大化面板",
  "Media unavailable": "媒体不可用",
  "Mention copied": "引用已复制",
  "Merge back to source conversation": "合并回来源会话",
  "Merge conflicts with": "存在合并冲突，目标：",
  "Merge this conversation back into its source": "将此会话合并回来源会话",
  "Message input": "消息输入",
  "Messages from apps need a started thread.": "请先开始会话，再发送应用消息。",
  "Mini PC": "迷你电脑",
  Minutes: "分钟",
  Modified: "修改时间",
  More: "更多",
  "More approval options": "更多审批选项",
  "More matches available. Refine your search.": "还有更多匹配项，请缩小搜索范围。",
  "More thread actions": "更多会话操作",
  "Mute tab": "标签页静音",
  "Needs a project and the Replay (dev) provider, which dev servers start.":
    "需要项目及开发服务器提供的 Replay (dev) 服务。",
  "Network error": "网络错误",
  "New model": "新模型",
  "Next match": "下一个匹配项",
  "Next media": "下一项媒体",
  "Next slide": "下一页幻灯片",
  "Next turn": "下一轮",
  "Nightly update release notes": "每日构建版更新说明",
  "No accessibility data": "没有无障碍数据",
  "No active project is available for this pull request.": "此拉取请求没有可用的活动项目。",
  "No agents yet": "暂无智能体",
  "No cells": "没有单元格",
  "No completed turns yet.": "尚无已完成的轮次。",
  "No description is available for this skill.": "此技能没有说明。",
  "No machine can read every attached thread. Choose a machine in the composer or remove the threads.":
    "没有电脑能读取全部附加会话。请选择电脑或移除会话附件。",
  "No matching actions.": "没有匹配的操作。",
  "No matching commands, projects, or threads.": "没有匹配的命令、项目或会话。",
  "No matching languages.": "没有匹配的语言。",
  "No matching refs.": "没有匹配的分支或标签。",
  "No models are available for this provider.": "此模型服务没有可用模型。",
  "No preview yet": "暂无预览",
  "No SSH route to": "没有可用的 SSH 路由：",
  "No threads in these projects yet": "这些项目中暂无会话",
  none: "无",
  "Not ready": "尚未就绪",
  Note: "说明",
  "of them.": "个文件。",
  "On another machine, so this machine's agent can't read it. Remove it or switch back to send.":
    "此内容位于另一台电脑，本机智能体无法读取。请移除，或切回原电脑后发送。",
  "Only a session that manages access here can answer this.":
    "仅可由拥有此处访问管理权限的会话响应。",
  "Only UTF-8 text and images can be opened inside an archive.":
    "压缩包内仅支持打开 UTF-8 文本和图片。",
  "Open a chat for this project and try again.": "请打开此项目的会话后重试。",
  "Open a surface": "打开面板",
  "Open automation": "打开自动任务",
  "Open browser in a profile": "使用指定配置打开浏览器",
  "Open chat": "打开会话",
  "Open DevTools": "打开开发者工具",
  "Open file in preview browser": "在预览浏览器中打开文件",
  "Open full screen": "全屏打开",
  "Open in browser": "在浏览器中打开",
  "Open in right panel": "在右侧面板打开",
  "Open in the browser panel.": "在浏览器面板中打开。",
  "Open on": "打开于",
  "Open on this computer": "在此电脑打开",
  "Open parent": "打开上级",
  "Open parent agent": "打开上级智能体",
  "Open parent thread": "打开上级会话",
  "Open provider setup": "打开模型服务配置",
  "Open provider setup to sign in with Google.": "打开模型服务配置，使用 Google 登录。",
  "Open provider setup to sign in.": "打开模型服务配置以登录。",
  "Open separate preview window": "打开独立预览窗口",
  "Open Settings -> Source control": "打开设置 → 版本控制",
  "Open Settings -> Source control to configure this provider.":
    "请打开设置 → 版本控制，配置此服务。",
  "Open source control settings": "打开版本控制设置",
  "Open subagent thread": "打开子智能体会话",
  "Open terminal": "打开终端",
  "Opening it in the environment’s browser, which reaches its network":
    "在该环境的浏览器中打开，以访问其网络",
  "Opens over SSH. Needs your key on": "通过 SSH 打开。需要在目标电脑配置你的密钥：",
  "Originally queued, then promoted to steer the active turn": "原为排队消息，现已用于调整当前轮次",
  "outline-none": "通知",
  Page: "页",
  "Pair this client again with preview access to control browser previews.":
    "请重新配对此客户端并授予预览访问权限，以控制浏览器预览。",
  "Parent agent": "上级智能体",
  "Parent folder": "上级文件夹",
  "Parent thread": "上级会话",
  "Partial diff preview": "部分差异预览",
  Paste: "粘贴",
  "Paste the code": "粘贴配对码",
  Pause: "暂停",
  "Pick where to host it, then point us at a repo to push to.":
    "选择托管平台，然后指定要推送的仓库。",
  "Plan mode. Click to return to normal build mode": "计划模式，点击返回执行模式",
  "Plan ready": "计划已就绪",
  "Please try again.": "请重试。",
  "Preparing file…": "正在准备文件…",
  "Press a shortcut. Use": "按下快捷键，使用",
  preview: "预览",
  "Preview access is unavailable for this client.": "当前客户端没有预览权限。",
  "Preview annotation": "预览标注",
  "Preview closed.": "预览已关闭。",
  "Preview is only available in the T3 Code desktop app.": "预览仅适用于 T3 Code 桌面应用。",
  "Preview limited to 1,000 pages.": "最多预览 1,000 页。",
  "Preview limited to 2,000 pages. Save this PDF to read it in full.":
    "最多预览 2,000 页，请保存 PDF 以完整阅读。",
  "Preview limited to files under 50 MB.": "仅支持预览小于 50 MB 的文件。",
  "Preview limited to presentations with 1 to 500 slides.": "仅支持预览 1 至 500 页的演示文稿。",
  "Preview limited to the first 1 MB": "仅预览前 1 MB",
  "Preview limited to the first 1 MB of a": "仅预览前 1 MB，文件总大小为",
  "Preview limited. Save it or open it in another app to read the full document.":
    "预览内容有限，请保存文件或使用其他应用查看完整文档。",
  "Preview menu": "预览菜单",
  "Previous agents": "先前的智能体",
  "Previous match": "上一个匹配项",
  "Previous media": "上一项媒体",
  "Previous slide": "上一页幻灯片",
  "Previous turn": "上一轮",
  "Profile:": "浏览器配置：",
  provider: "个模型服务",
  "Provider process is gone. Interrupt or restart the run to respond.":
    "模型服务进程已退出。请中断或重新开始执行后再响应。",
  "Provider settings": "模型服务设置",
  "Provider status unavailable. Open Settings -> Source control and rescan.":
    "服务状态不可用，请打开设置 → 版本控制并重新扫描。",
  "Publishing repository to": "正在发布仓库到",
  "Pull failed": "拉取失败",
  "Pull requests are not available for this project.": "此项目不支持拉取请求。",
  "Pull requests could not be read for this project.": "无法读取此项目的拉取请求。",
  Pulled: "已拉取",
  "Push to default ref?": "推送到默认分支或标签？",
  queued: "排队中",
  Queued: "排队中",
  Ran: "已运行",
  "Re-add it if you want that terminal output included.": "如需包含该终端输出，请重新添加。",
  "Read file": "读取文件",
  "Read more": "查看详情",
  "Read-only connection. Unsaved edits are kept until write access returns.":
    "当前为只读连接，未保存的编辑会保留至写入权限恢复。",
  "Read-only. Up to 50 columns and 1,024 characters per cell. Blob contents are omitted.":
    "只读，最多显示 50 列，每个单元格最多 1,024 个字符，不显示二进制内容。",
  "Reasoning effort": "推理力度",
  "Recent Threads": "最近会话",
  "Recently used": "最近使用",
  "Reconnect this machine to update": "重新连接此电脑后更新",
  "Reconnect to the environment and try again.": "请重新连接环境后重试。",
  "Reconnect to this environment and open the media again.": "请重新连接此环境，再打开媒体。",
  "Recording saved": "录制已保存",
  Recursive: "递归",
  "Refresh Antigravity models in provider settings before sending.":
    "请先在模型服务设置中刷新 Antigravity 模型，再发送消息。",
  "Refresh diff": "刷新差异",
  "Refresh failed. Retry": "刷新失败，点击重试",
  "Refresh files": "刷新文件",
  "Refresh workspace files": "刷新工作区文件",
  "Refreshing diff": "正在刷新差异",
  "Refreshing diff…": "正在刷新差异…",
  "Related threads": "相关会话",
  "Relative path": "相对路径",
  "Relaunch command copied": "重启命令已复制",
  "remaining)": "项剩余）",
  "Remote only": "仅远端",
  "Remove from draft": "从草稿中移除",
  "Remove from queue": "移出队列",
  "Remove it or re-add it to include terminal output.": "请移除后重新添加，以包含终端输出。",
  "Remove queued message": "移除排队消息",
  "Removed profile": "浏览器配置已移除",
  Rename: "重命名",
  "Replaced by a newer call": "已被更新的调用替代",
  "Replay a recorded turn": "回放已录制的轮次",
  "Replay failed": "回放失败",
  "Replay needs a dev server with a project and the Replay (dev) provider.":
    "回放需要开发服务器、项目以及 Replay (dev) 服务。",
  "Request copied": "申请已复制",
  "Request failed.": "请求失败。",
  "Reset time unavailable; retry manually": "重置时间不可用，请手动重试",
  "Reset zoom": "重置缩放",
  "Resize Sidebar": "调整侧栏宽度",
  "Resolve a": "解析",
  "Resolved (native)": "已解决（原生）",
  "Resolved (portable)": "已解决（跨端）",
  Resolving: "正在解析",
  "Restart the app from the update button to install it.": "请使用更新按钮重启应用以安装。",
  "Restart to update": "重启以更新",
  "restarts last": "最后重启",
  "Restore panel size": "恢复面板大小",
  "Resume at reset": "重置后恢复",
  "Retry loading diff": "重试加载差异",
  Reverted: "已回退",
  "Review link…": "检查关联…",
  "Review your usage settings in ChatGPT.": "请在 ChatGPT 中查看用量设置。",
  "rows ·": "行 ·",
  "rows)": "行）",
  "Run interrupted": "执行已中断",
  running: "运行中",
  "Runs on its own": "独立运行于",
  Saturation: "饱和度",
  "Save file": "保存文件",
  "Save it or open it in another app.": "请保存文件或使用其他应用打开。",
  "Save it to open in an app that supports": "请保存后使用支持此格式的应用打开：",
  "Save it to open in another app.": "请保存后使用其他应用打开。",
  "Save securely": "安全保存",
  saving: "正在保存",
  "Screenshot saved": "截图已保存",
  "Screenshot unavailable": "截图不可用",
  "Scroll display equation": "滚动独立公式",
  "Scroll inline equation": "滚动行内公式",
  "Scroll panel tabs": "滚动面板标签页",
  "Scroll tabs left": "向左滚动标签页",
  "Scroll tabs right": "向右滚动标签页",
  "Search failed": "搜索失败",
  "Search files": "搜索文件",
  "Search languages": "搜索语言",
  "Search models...": "搜索模型…",
  "Search result": "搜索结果",
  "Searching workspace files…": "正在搜索工作区文件…",
  "Select a live local server to open it in this browser tab.":
    "选择正在运行的本地服务器，在此浏览器标签页打开。",
  "Select a thread to inspect turn diffs.": "选择会话以查看各轮次的文件差异。",
  "Select ref": "选择分支或标签",
  "Selection is too long to cite": "所选内容过长，无法引用",
  "Send again when it's ready.": "准备完成后请重新发送。",
  "Send into the current turn": "发送到当前轮次",
  "Send it to your workspace admin.": "请发送给工作区管理员。",
  "Send now": "立即发送",
  server: "台服务器",
  Servers: "服务器",
  "Setting up worktree…": "正在设置工作树…",
  "Settings sections": "设置分类",
  "Setup progress": "设置进度",
  "Setup script": "设置脚本",
  Sheets: "工作表",
  "Shorten selection": "缩短所选内容",
  "Show accessibility JSON": "显示无障碍 JSON",
  "Show app": "显示应用",
  "Show device toolbar": "显示设备工具栏",
  "Show extracted text": "显示提取的文本",
  "Show fewer": "收起",
  "Show file explorer": "显示文件浏览器",
  "Show full script": "显示完整脚本",
  "Show HTML source": "显示 HTML 源码",
  "Show markdown source": "显示 Markdown 源码",
  "Show Mermaid source": "显示 Mermaid 源码",
  "Show more cells (": "显示更多单元格（",
  "Show rendered diagram": "显示渲染后的图表",
  "Show rendered markdown": "显示渲染后的 Markdown",
  "Show rendered page": "显示渲染后的页面",
  "Show screenshot": "显示截图",
  "Show source": "显示源码",
  "Show table": "显示表格",
  "Show whitespace changes": "显示空白更改",
  "Showing the first": "仅显示前",
  "Showing the first 1,024 columns. Source and Save retain every column.":
    "仅显示前 1,024 列；源码和保存操作会保留全部列。",
  "Showing the source response. The saved quote is unchanged.":
    "正在显示来源回复，保存的引用未改变。",
  "Sign in to Antigravity in provider settings before sending.":
    "请先在模型服务设置中登录 Antigravity，再发送消息。",
  "Sign in via the CLI to authenticate again.": "请通过命令行重新登录认证。",
  Size: "大小",
  Skip: "跳过",
  "Skip compaction and send this message": "跳过压缩并发送此消息",
  skipped: "已跳过",
  Slide: "幻灯片",
  SnapShots: "界面快照",
  "Snooze for": "稍后提醒时长",
  "Snooze until reset": "稍后提醒至重置时",
  "Some requests are slow": "部分请求响应缓慢",
  "Speaker notes": "演讲者备注",
  "Start a new chat to switch providers": "新建会话以切换模型服务",
  "Start a turn with this message": "使用此消息开始新一轮",
  "Start work": "开始工作",
  Started: "已开始",
  "Started by an agent on": "由智能体启动，所在位置：",
  Starting: "正在启动",
  Steer: "调整方向",
  "Steered the active turn": "已调整当前轮次方向",
  "Stop entire workflow": "停止整个工作流",
  "Stop server": "停止服务器",
  "Stop subagent": "停止子智能体",
  Stopped: "已停止",
  Subagent: "子智能体",
  "Subagent of": "子智能体，所属会话：",
  "Subagent waiting": "子智能体等待中",
  Suggestions: "建议",
  Superseded: "已被替代",
  "Superseded attempt": "已被新尝试替代",
  "Sync ref": "同步分支或标签",
  "Terminal drawer is unavailable": "终端面板不可用",
  "Text and images. Layout and embedded objects may differ from the original.":
    "显示文本和图片，排版与嵌入对象可能与原文不同。",
  "that another machine can reach. Enter its https or Tailscale address.":
    "。请输入其 HTTPS 或\n                        Tailscale 地址。",
  "That Antigravity model is no longer available. Choose another model.":
    "该 Antigravity 模型已不可用，请选择其他模型。",
  "That snooze time has passed. Choose another time.": "该提醒时间已过，请选择其他时间。",
  The: "该",
  "The agent is actively controlling these browsers. Closing them may interrupt the current browser actions.":
    "智能体正在操作这些浏览器，关闭可能中断当前操作。",
  "The agent is actively controlling this browser. Closing it may interrupt the current browser action.":
    "智能体正在操作此浏览器，关闭可能中断当前操作。",
  "The agent reads T3 Code's logs and source here, and asks before it applies a fix or posts anything.":
    "智能体会读取此处的 T3 Code 日志和源码，执行修复或发布内容前会询问你。",
  "The annotation was kept without the screenshot.": "已保留标注，未附带截图。",
  "The app or capture backend did not provide verified accessibility data.":
    "应用或采集后端未提供已验证的无障碍数据。",
  "The call was aborted": "调用已中止",
  "The chat isn't ready to accept input right now.": "会话目前无法接受输入。",
  "The citation does not refer to an assistant response": "此引用未指向智能体回复",
  "The cited response is unavailable": "引用的回复不可用",
  "The clone failed.": "克隆失败。",
  "The diagram renderer failed to load.": "图表渲染器加载失败。",
  "The environment it came from is not reachable right now.": "目前无法访问来源环境。",
  "The environment returned an invalid attachment URL.": "环境返回了无效的附件地址。",
  "The environment returned an invalid media URL.": "环境返回了无效的媒体地址。",
  "The file could not be accessed or read. It may be missing or inaccessible.":
    "无法访问或读取文件，可能不存在或无权访问。",
  "The file could not be loaded. Close it and try again.": "文件加载失败，请关闭后重试。",
  "The file could not be loaded. It may have been moved or deleted.":
    "文件加载失败，可能已被移动或删除。",
  "The file could not be loaded. Try again.": "文件加载失败，请重试。",
  "The file is binary and cannot be displayed as text.": "文件包含二进制数据，无法作为文本显示。",
  "The file is unavailable.": "文件不可用。",
  "The font could not be decoded.": "无法解码字体。",
  "The font could not be loaded.": "无法加载字体。",
  "The font is damaged or unsupported.": "字体已损坏或不受支持。",
  "The font is unavailable.": "字体不可用。",
  "The guest sees the thread as you do, including command output and the agent's reasoning. Each message they send waits for you.":
    "访客可看到与你相同的会话内容，包括命令输出与智能体推理。访客发送的每条消息都需要你确认。",
  "The Office engine sent an unreadable reply": "Office 引擎返回了无法读取的响应",
  "The Office engine stopped": "Office 引擎已停止",
  "The Office engine was closed": "Office 引擎已关闭",
  "The original attachment is no longer available.": "原附件已不可用。",
  "The path is a directory or special file, not a regular file.":
    "此路径是目录或特殊文件，而非常规文件。",
  "The path resolves to a location outside the workspace.": "路径解析后指向工作区之外。",
  "The provider recorded file content without a diff.": "模型服务记录了文件内容，但未记录差异。",
  "The quoted text has changed": "引用文本已变化",
  "The requested path is outside the workspace.": "请求路径位于工作区之外。",
  "The reset time has passed. Retry the thread manually.": "重置时间已过，请手动重试会话。",
  "The selected environment": "所选环境",
  "The selected text is still saved in your citation.": "所选文本仍保存在引用中。",
  "The text viewer stopped.": "文本查看器已停止。",
  "The thread has changed. Select a message to rewind again.":
    "会话已变化，请重新选择要回退的消息。",
  "The workspace folder could not be accessed.": "无法访问工作区文件夹。",
  "this app": "此应用",
  "This app": "此应用",
  "This app has no address for": "此应用未记录可供其他电脑访问的地址：",
  "This browser cannot draw slides.": "此浏览器无法绘制幻灯片。",
  "This connection cannot browse host folders.": "当前连接无法浏览主机文件夹。",
  "This connection cannot change one or more selected threads.": "当前连接无法修改部分所选会话。",
  "This connection cannot change source control.": "当前连接无法更改版本控制。",
  "This connection cannot change the thread's branch.": "当前连接无法更改会话分支。",
  "This connection cannot read host files.": "当前连接无法读取主机文件。",
  "This connection cannot read local diffs.": "当前连接无法读取本地差异。",
  "This connection cannot reveal files on this environment.": "当前连接无法在此环境中定位文件。",
  "This context is no longer available.": "此上下文已不可用。",
  "This context is no longer available. Remove it or attach it again.":
    "此上下文已不可用，请移除或重新添加。",
  "This diagram contains resource URLs, markup, node metadata, or custom configuration. Show Mermaid source to inspect it safely.":
    "此图包含资源地址、标记、节点元数据或自定义配置。请切换到 Mermaid 源码以安全查看。",
  "This document took too long to preview. Open it in another app.":
    "文档预览超时，请使用其他应用打开。",
  "This embedded image exceeds the preview pixel limit.": "此嵌入图片超出预览像素限制。",
  "This environment is already linked to": "此环境已关联到",
  "This file can’t be shown here": "无法在此处显示此文件",
  "This file is empty.": "此文件为空。",
  "This file is too large to preview.": "此文件过大，无法预览。",
  "This file is too large to show in full. Counts include all changes.":
    "文件过大，无法完整显示。统计包含全部更改。",
  "This file is unavailable or too large to preview.": "此文件不可用或过大，无法预览。",
  "This file is unavailable.": "此文件不可用。",
  "This image could not be loaded.": "无法加载此图片。",
  "This install is using the correct architecture.": "当前安装版本的处理器架构正确。",
  "This Mac has Apple Silicon, but T3 Code is still running the Intel build under Rosetta. Download the available update to switch to the native Apple Silicon build.":
    "此 Mac 使用 Apple Silicon，但 T3 Code 仍通过 Rosetta 运行 Intel 版本。请下载可用更新以切换到原生版本。",
  "This Mac has Apple Silicon, but T3 Code is still running the Intel build under Rosetta. Restart to install the downloaded Apple Silicon build.":
    "此 Mac 使用 Apple Silicon，但 T3 Code 仍通过 Rosetta 运行 Intel 版本。请重启以安装已下载的原生版本。",
  "This Mac has Apple Silicon, but T3 Code is still running the Intel build under Rosetta. The next app update will replace it with the native Apple Silicon build.":
    "此 Mac 使用 Apple Silicon，但 T3 Code 仍通过 Rosetta 运行 Intel 版本。下次更新将替换为原生版本。",
  "This merges #": "这将合并 #",
  "This message has an attachment that cannot be restored.": "此消息包含无法恢复的附件。",
  "This PDF has too much text to search. Save it to search in another app.":
    "此 PDF 文本过多，无法搜索。请保存后使用其他应用搜索。",
  "This PDF page could not render.": "无法渲染此 PDF 页面。",
  "This preview exceeds the size limit. Changes shown are incomplete.":
    "预览超出大小限制，显示的更改不完整。",
  "This related thread is unavailable": "此关联会话不可用",
  "This server does not accept file attachments right now. Remove the files to send.":
    "此服务器目前不接受文件附件。请移除文件后发送。",
  "This site can’t be reached": "无法访问此网站",
  "This tab is open in the T3 Code desktop app.": "此标签页已在 T3 Code 桌面应用中打开。",
  "This thread does not support switching providers after it has started.":
    "此会话开始后不支持切换模型服务。",
  "This thread is no longer available": "此会话已不可用",
  "This tool call changed": "此工具调用更改了",
  "This workbook has no visible sheets.": "此工作簿没有可见工作表。",
  Thought: "已思考",
  "Thread action unavailable": "会话操作不可用",
  "Thread breadcrumb": "会话路径",
  "Thread completed": "会话已完成",
  "Thread failed": "会话失败",
  "Thread no longer available": "会话已不可用",
  "through a linked environment.": "通过关联环境。",
  "Timed out waiting for the thread to rewind.": "等待会话回退超时。",
  Tip: "提示",
  "to start": "以开始",
  "Toggle right panel": "展开或收起右侧面板",
  "Toggle terminal drawer": "展开或收起终端面板",
  "Toggle thread details": "展开或收起会话详情",
  "Toggle thread details panel": "展开或收起会话详情面板",
  "Tool call": "工具调用",
  "Tool call failed": "工具调用失败",
  "Tool calls": "工具调用",
  "Tool output image": "工具输出图片",
  "Top level only": "仅顶层",
  "Triage an issue": "排查问题",
  "Try again.": "请重试。",
  "Try:": "请尝试：",
  Turn: "轮次",
  "Turn diffs are unavailable because this project is not a git repository.":
    "此项目不是 Git 仓库，无法显示轮次差异。",
  "Type a URL above, or run a dev script. Browser-ready localhost servers will show up here automatically.":
    "在上方输入网址，或运行开发脚本。可供浏览器访问的本机服务器会自动显示于此。",
  "Unable to capture screenshot": "无法截图",
  "Unable to change the browser tab": "无法更改浏览器标签页",
  "Unable to copy recording path": "无法复制录制文件路径",
  "Unable to load": "无法加载",
  "Unable to load audio.": "无法加载音频。",
  "Unable to load file preview.": "无法加载文件预览。",
  "Unable to load folder.": "无法加载文件夹。",
  "Unable to load image.": "无法加载图片。",
  "Unable to load the": "无法加载",
  "Unable to load workspace image.": "无法加载工作区图片。",
  "Unable to move the browser tab": "无法移动浏览器标签页",
  "Unable to open link in browser": "无法在浏览器中打开链接",
  "Unable to open PDF.": "无法打开 PDF。",
  "Unable to open release notes": "无法打开更新说明",
  "Unable to render diagram:": "无法渲染图表：",
  "Unable to start recording": "无法开始录制",
  "Unable to stop recording": "无法停止录制",
  Uncommitted: "未提交",
  Unit: "单位",
  "Unmute tab": "取消标签页静音",
  "Untitled thread": "未命名会话",
  "Up to date": "已是最新",
  "Update available for": "发现可用更新：",
  "Update did not apply": "更新未生效",
  "Update downloaded": "更新已下载",
  "Update failed": "更新失败",
  "Updates unavailable": "更新不可用",
  "Use this link": "使用此关联",
  "User message": "用户消息",
  using: "使用",
  "Using ChatGPT plan": "使用 ChatGPT 套餐",
  "View accessibility data": "查看无障碍数据",
  "View instructions": "查看说明",
  vs: "与",
  "Waiting for approval": "等待审批",
  "Waiting for the server before file attachments can send": "正在等待服务器，以发送文件附件",
  "Waiting on": "正在等待",
  "Watch an iOS Simulator or Android Emulator.": "查看 iOS 或 Android 模拟器。",
  "Web search": "网页搜索",
  "What should we build": "开始工作",
  "What went wrong?": "遇到了什么问题？",
  "Work locally": "在本机执行",
  Worked: "已执行",
  "Working for": "正在执行，用时",
  "Workspace folder:": "工作区文件夹：",
  "Workspace panel": "工作区面板",
  "Workspace query failed.": "查询工作区失败。",
  Workstation: "工作站",
  "Worktree ready": "工作树已就绪",
  "Worktree ready, setup script failed": "工作树已就绪，设置脚本失败",
  "Worktree setup": "工作树设置",
  "Worktree setup cancelled": "工作树设置已取消",
  "Worktree setup failed": "工作树设置失败",
  You: "你",
  "You stopped this response": "你已停止此回复",
  "You've reached your workspace's limit for using your ChatGPT plan in other apps. Copy a request to ask your workspace admin for increased usage limits.":
    "你在其他应用中使用 ChatGPT 套餐的工作区用量已达上限。复制申请，请工作区管理员提高限额。",
  "Your message changed, so it wasn't sent.": "消息发生变化，因此未发送。",
  'Your prompt contains "ultrathink" in the text. Remove it to change this option.':
    "输入文本包含 ultrathink，请移除后再更改此选项。",
  Zoom: "缩放",
};
